import { Pagination } from 'swiper';
import Swiper from 'swiper';

Swiper.use([Pagination]);

window.onload = function(){
    new Swiper('.swiper', {
        spaceBetween: 20,
        slidesPerView: 'auto',
        slidesPerGroup: 4,
        grabCursor: true,
        longSwipes: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        breakpoints: {
            // when window width is < 325px
            0: {
                slidesPerGroup: 1,
                spaceBetween: 0
            },
            // when window width is >= 325px
            325: {
                slidesPerGroup: 2,
                spaceBetween: 20
            },
            // when window width is >= 984px
            984: {
                slidesPerGroup: 3,
            },
            // when window width is >= 984px
            1000: {
                slidesPerView: 'auto',
                slidesPerGroup: 4,
            }
        },
        speed: 1000,
    });
}
